"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Accordion = require("b2b-components/theme/components/Accordion");
var _device = require("b2b-components/utils/device");
var _classnames = _interopRequireDefault(require("classnames"));
var _TabHeader = require("./TabHeader");
var _Tabs = require("./Tabs.types");
var _ = require("./");
require("./Tabs.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Tabs = function Tabs(_ref) {
  var children = _ref.children,
    selectedTabIdx = _ref.selectedTabIdx,
    deviceType = _ref.deviceType,
    _ref$displayType = _ref.displayType,
    displayType = _ref$displayType === void 0 ? _Tabs.TABS_DISPLAY_TYPE.horizontal : _ref$displayType,
    triggerType = _ref.triggerType,
    className = _ref.className;
  var componentClassNames = displayType === _Tabs.TABS_DISPLAY_TYPE.horizontal ? {
    container: 'cds-TabsContainer--Horizontal',
    tabs: 'cds-Tabs--Horizontal',
    content: 'cds-TabContent--Horizontal'
  } : {
    container: 'cds-TabsContainer--Vertical',
    tabs: 'cds-Tabs--Vertical',
    content: 'cds-TabContent--Vertical'
  };
  var _useState = (0, _react.useState)(selectedTabIdx || 0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  if ((0, _device.isMobile)(deviceType)) {
    return /*#__PURE__*/_react["default"].createElement(_Accordion.Accordion, {
      defaultOpenIndexArray: [0],
      sectionClassName: "cds-TabHeader--Mobile",
      sectionTitleClassName: "cds-TabHeaderTitle--mobile",
      className: className
    }, children.map(function (tab, idx) {
      return /*#__PURE__*/_react["default"].createElement(_Accordion.Accordion.Section, {
        key: idx,
        title: tab.props.title,
        titleSize: _Accordion.TITLE_SIZE.large
      }, tab);
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(componentClassNames.container, className)
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _classnames["default"])('cds-Tabs', componentClassNames.tabs)
  }, children.map(function (tab, idx) {
    var _tab$props = tab.props,
      tabTitle = _tab$props.title,
      tabTriggerType = _tab$props.triggerType,
      className = _tab$props.className;
    return /*#__PURE__*/_react["default"].createElement(_TabHeader.TabHeader, {
      key: idx,
      title: tabTitle,
      isActive: idx === activeTab,
      onTrigger: function onTrigger() {
        return setActiveTab(idx);
      },
      triggerType: tabTriggerType || triggerType,
      className: className
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('cds-TabContent', componentClassNames.content)
  }, children.filter(function (tab, idx) {
    return idx === activeTab;
  }).map(function (tab, idx) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: idx
    }, tab);
  })));
};
exports.Tabs = Tabs;
Tabs.Tab = _.Tab;